import Vue from "vue";
import { apiOpsBff, memory, memoryPrivate, usersBff } from "ngt-frontend-core";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import { i18n } from "@/locales/i18n";
import PortalVue from "portal-vue";
import VueObserveVisibility from "vue-observe-visibility";
import "@/filters/commonDataFilters";
import "@/mixins/commonDataMixins";
import ServiceProviderPlugin from "@/plugins/provider";

// Add this fo install vuetify-dialog
import VuetifyDialog from "vuetify-dialog";
import "vuetify-dialog/dist/vuetify-dialog.min.css";

import dayjs from "dayjs";
import "dayjs/locale/hu";
// import "dayjs/locale/nb";
var timezone = require("dayjs/plugin/timezone");
dayjs.extend(timezone);
var utc = require("dayjs/plugin/utc");
dayjs.extend(utc);
var weekday = require("dayjs/plugin/weekday");
dayjs.extend(weekday);

// tmp - remove traces of old login and data storage
memory.remove("user");
localStorage.removeItem("appSettingsReportManager");

// THIS IS IMPORTANT TO INSTALL DIALOGS
// YOU NEED TO SEND VUETIFY INSTANCE INTO DIALOG CONTEXT
Vue.use(VuetifyDialog, {
  context: {
    vuetify,
  },
});

Vue.use(PortalVue);
Vue.use(VueObserveVisibility);
Vue.use(ServiceProviderPlugin);

Vue.prototype.$EventBus = new Vue();

Vue.config.productionTip = false;

async function main() {
  // console.log("main started")

  apiOpsBff.connectWithStore(store, i18n);
  usersBff.initializeLogin(router, store);

  const user = await memoryPrivate.getItemAsync("user");
  store.commit("user", user || false);

  const actionsData = require("@/app-data/actions.json");
  store.state.actionsData = actionsData;

  const lookups = require("@/app-data/lookups.json");
  store.state.lookups = lookups;

  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
  }).$mount("#app");
}

if (process.env.TYPE === undefined || process.env.TYPE === "browser") {
  main();
} else {
  document.addEventListener("deviceready", main);
}
